import React from 'react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Segment, Header, Card, Icon, Grid, Loader, Button} from 'semantic-ui-react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import _ from 'lodash';
import {
  convertDateForDisplay,
  convertValueToDollar,
  safeAdd,
  safeSubstract,
  displayObjectErrors,
  evaluateTemplateString,
} from 'common/utils';
import {ALWAYS_DIRTY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import {DeleteModal} from 'app-ui-componentlibrary';
import {connectWithCore} from 'framework/hocs';
import {Link} from 'react-router-dom';

//direct = SAFER, FP&S, AFG
//bric = BRIC/HMA

// user for BRIC only
const REGIONS = ['HQ', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

export class FundingInformationSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
      commitmentsInUse: [],
      returnedCommitments: [],
      regionFilter: null,
      awardRecStatusSet: new Set(),
      commitmentNumberFilter: '',
      entityMap: {},
      selectedCommitments: [],
      retrievingCommitments: false,
      loadingEntityData: false,
      regions: [
        {
          key: '',
          value: null,
          text: '',
        },
      ],
      selectedEntity: null,
      selectedEntityIndex: null,
      modalOpen: false,
      deleteModalOpen: false,
      deleteModalCommitment: {},
      deleteModalEntity: '',
      error: false,
      errorMessage: '',
    };
  }

  getEntityErrors(entityIndex) {
    const {validationErrors, entityType} = this.props;
    let fieldname = entityType;
    // need to check after validation is implemented
    let objPath = this.props.hasSingleEntity
      ? `0.${fieldname}.${entityIndex}`
      : `0.${fieldname}.0.error.${entityIndex}`;
    let errors = _.get(validationErrors, objPath);
    return errors;
  }

  getSingleCommitmentErrors(entityIndex) {
    let fieldname = 'singleCommitment';
    let entityErrors = this.getEntityErrors(entityIndex);
    let errors = _.get(entityErrors, `${fieldname}.0`, {isValid: true});
    return errors;
  }

  getCommitmentErrors(entityIndex, commitmentIndex) {
    let fieldname = 'commitment';
    let entityErrors = this.getEntityErrors(entityIndex);
    // need to check after validation is implemented
    let errors = _.get(entityErrors, `${fieldname}.0.error.${commitmentIndex}`);
    return errors;
  }

  getFedShareErrors(entityIndex) {
    let fieldname = 'fedShare';
    let entityErrors = this.getEntityErrors(entityIndex);
    let errors = _.get(entityErrors, `${fieldname}.0`, {isValid: true});
    return errors;
  }

  displayCommitmentError(entityIndex, commitmentIndex, fieldname) {
    let commitmentErrors = this.getCommitmentErrors(entityIndex, commitmentIndex);
    let result = displayObjectErrors(commitmentErrors, ALWAYS_DIRTY_MAP, fieldname);
    return result;
  }

  componentDidMount() {
    this.initializeComponent();
  }

  componentDidUpdate(oldProps) {
    let propsToUpdate = _.pick(oldProps, [
      'entityType',
      'filterConfig',
      'cardHeaders',
      'data',
    ]);
    let updatedProps = _.pick(this.props, [
      'entityType',
      'filterConfig',
      'cardHeaders',
      'data',
    ]);
    let commitmentsToUpdate = _.map(
      oldProps.subAwardRecommendations,
      (entity) => entity.payload.commitment
    );
    let updatedCommitments = _.map(
      this.props.subAwardRecommendations,
      (entity) => entity.payload.commitment
    );
    if (
      !_.isEqual(propsToUpdate, updatedProps) ||
      !_.isEqual(commitmentsToUpdate, updatedCommitments)
    ) {
      this.initializeComponent();
    }
  }

  initializeComponent = () => {
    /* Below is necessary due to some entities having a mismatch in status (like subAwardRecommendation not being updated after PAPR) */
    let subOrgs = _.get(this.props, 'subOrganizations', []);
    let organization = _.get(this.props, 'organization', {});
    let commitmentData = _.get(
      this.props,
      'fundingOpportunityData.fundingOpportunityCommitment'
    );
    let regions = _.uniqBy(
      [
        {
          key: '',
          value: null,
          text: '',
        },
        ..._.map(commitmentData, (commitment) => {
          return {
            key:
              commitment.commitmentRegion == 0
                ? 'HQ'
                : REGIONS[commitment.commitmentRegion],
            value: commitment.commitmentRegion,
            text:
              commitment.commitmentRegion == 0
                ? 'HQ'
                : REGIONS[commitment.commitmentRegion],
          };
        }),
      ],
      'value'
    );
    const data = _.get(this.props, 'data', []);
    let filteredEntities = data instanceof Array ? data : [data];
    let entityMap = {};
    let commitmentsInUse = [];
    _.forEach(filteredEntities, (filteredEntity) => {
      let entityId = _.get(filteredEntity, 'entityId');
      let commitments = _.get(filteredEntity, 'payload.commitment', []);
      if (_.isNull(commitments)) {
        commitments = [];
      }
      const entityCommitments =
        commitments instanceof Array ? commitments : [commitments];
      let subOrgData = _.find(subOrgs, (subOrg) => {
        return subOrg.organizationId == _.get(filteredEntity, 'subOrgId');
      });
      if (subOrgData && !subOrgData.region) {
        subOrgData = {
          ...subOrgData,
          region: organization.region,
        };
      }
      // for the data path
      let entityIndex = _.findIndex(
        filteredEntities,
        (entity) => entity.entityId === entityId
      );
      commitmentsInUse = _.concat(commitmentsInUse, entityCommitments);
      entityMap[entityId] = {
        commitment: entityCommitments,
        entity: filteredEntity,
        subOrganization: subOrgData,
        entityIndex: entityIndex,
        organization: organization,
      };
    });

    // preventing saved award amounts from being included in newly added commitments
    commitmentsInUse = _.map(
      _.uniqWith(commitmentsInUse, this.compareCommitments),
      (commitment) => {
        return {...commitment, awardAmount: undefined};
      }
    );
    this.setState(
      {
        entityMap: entityMap,
        entities: _.sortBy(filteredEntities, (entity) => entity.entityId),
        regions: regions,
        loadingEntityData: true,
      },
      () => {
        this.refreshCommitmentsInUse().then((commitmentsInUse) => {
          this.setState({
            loadingEntityData: false,
            commitmentsInUse: commitmentsInUse,
          });
        });
      }
    );
  };

  onRegionChange = (e) => {
    this.setState({
      regionFilter: parseInt(e.target.value),
    });
  };

  onCommitmentNumberChange = (e) => {
    this.setState({
      commitmentNumberFilter: e.target.value,
    });
  };

  handleCheckBoxChange = (commitment, value) => {
    let {selectedCommitments} = this.state;
    if (!_.includes(selectedCommitments, commitment)) {
      selectedCommitments = [...selectedCommitments, commitment];
    } else {
      _.remove(selectedCommitments, (c) => this.compareCommitments(c, commitment));
    }
    this.setState({
      selectedCommitments: selectedCommitments,
    });
  };

  handleAmountChange = (commitment, entity, value) => {
    let {entityMap} = this.state;
    let newEntityMap = entityMap;
    let commitmentsForEntity = newEntityMap[entity.entityId].commitment;
    let commitmentsForEntityCopy = [...commitmentsForEntity];
    let indexToChange = _.findIndex(commitmentsForEntityCopy, (c) => {
      return this.compareCommitments(c, commitment);
    });
    commitmentsForEntityCopy[indexToChange] = {
      ...commitmentsForEntityCopy[indexToChange],
      awardAmount: value,
    };
    newEntityMap[entity.entityId] = {
      ...newEntityMap[entity.entityId],
      commitment: commitmentsForEntityCopy,
    };
    this.setState({
      entityMap: newEntityMap,
    });
  };

  filterCommitments = (commitmentList, commitmentsToFilter) => {
    return _.differenceWith(commitmentList, commitmentsToFilter, this.compareCommitments);
  };

  compareCommitments = (commitment1, commitment2) => {
    return (
      commitment1.commitmentNumberId === commitment2.commitmentNumberId &&
      commitment1.commitmentLineNumber === commitment2.commitmentLineNumber
    );
  };

  retrieveCommitments(commitmentArray) {
    const commitmentData = _.get(
      this.props,
      'fundingOpportunityData.fundingOpportunityCommitment'
    );

    const commitmentsToSearch = _.uniq(
      _.map(commitmentArray, (commitment) => {
        return {
          commitmentNumberId: commitment.commitmentNumberId,
          commitmentLineNumber: commitment.commitmentLineNumber,
        };
      })
    );
    let responses = _.map(commitmentsToSearch, (commitmentInfo) => {
      return this.props.getCommitment(
        this.props.token,
        commitmentInfo.commitmentNumberId
      );
    });

    return Promise.all(responses)
      .then((results) => {
        let resultArray = _.concat(
          ..._.map(
            results,
            (commitmentResponse) => commitmentResponse.payload.commitmentDetailsResponse
          )
        );

        _.forEach(resultArray, (returnedCommitment) => {
          returnedCommitment.commitmentLineNumber = formatLineNumber(
            returnedCommitment.commitmentLineNumber.toString()
          );
          let region = _.get(
            _.find(
              commitmentData,
              (data) => data.commitmentNumbers === returnedCommitment.commitmentNumberId
            ),
            'commitmentRegion'
          );
          if (region || region == 0) {
            returnedCommitment.region = REGIONS[region];
          }
        });

        return _.map(commitmentArray, (commitmentInfo) => {
          let returnedCommitment = _.find(resultArray, (commitment) =>
            this.compareCommitments(commitmentInfo, commitment)
          );
          return {
            ...returnedCommitment,
            awardAmount: commitmentInfo.awardAmount,
          };
        });
      })
      .catch((e) => {
        throw e;
      });
  }

  retrieveCommitmentsToAdd = () => {
    const commitmentData = _.get(
      this.props,
      'fundingOpportunityData.fundingOpportunityCommitment'
    );
    let {regionFilter, commitmentNumberFilter, commitmentsInUse} = this.state;
    const commitmentsToSearch = _.map(
      this.filterCommitments(
        _.filter(commitmentData, (data) => {
          return (regionFilter || regionFilter == 0) && commitmentNumberFilter
            ? data.commitmentRegion === regionFilter &&
                data.commitmentNumbers === commitmentNumberFilter
            : ((regionFilter || regionFilter == 0) &&
                data.commitmentRegion === regionFilter) ||
                (commitmentNumberFilter &&
                  data.commitmentNumbers === commitmentNumberFilter);
        }),
        commitmentsInUse
      ),
      (filteredData) => {
        return {
          id: filteredData.commitmentNumbers,
          region: filteredData.commitmentRegion,
        };
      }
    );

    const returnedCommitments = [];

    let responses = _.map(commitmentsToSearch, (commitment) => {
      return this.props.getCommitment(this.props.token, commitment.id);
    });

    Promise.all(responses)
      .then((results) => {
        // all returned commitment data
        _.forEach(results, (result) => {
          let data = result.payload;
          // all commitments for one commitment number
          let commitmentDetails = data.commitmentDetailsResponse;
          _.forEach(commitmentDetails, (returnedCommitment) => {
            returnedCommitment.commitmentLineNumber = formatLineNumber(
              returnedCommitment.commitmentLineNumber.toString()
            );
            let region = _.get(
              _.find(
                commitmentData,
                (data) => data.commitmentNumbers === returnedCommitment.commitmentNumberId
              ),
              'commitmentRegion'
            );
            if (region >= 0) {
              returnedCommitment.region = REGIONS[region];
            }
            returnedCommitments.push(returnedCommitment);
          });
        });

        this.setState({
          returnedCommitments: returnedCommitments,
          retrievingCommitments: false,
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          error: true,
          errorMessage: e,
          retrievingCommitments: false,
        });
      });
  };

  addCommitmentsToEntity = (entityId) => {
    const selectedCommitments = this.state.selectedCommitments;
    const fedSharePath = _.get(
      this.props,
      fedSharePath,
      'payload.budget.share.fedShare[0]'
    );
    let {entityMap, commitmentsInUse} = this.state;
    let entity = _.get(entityMap[entityId], 'entity');
    let fedShare = _.get(entity, fedSharePath, 0);
    let newEntityMap = entityMap;

    const {toggles, fundingOpportunityData} = this.props;
    const fundingOpportunityId = _.get(fundingOpportunityData, 'fundingOpportunityId');
    const amendExistingScopeObligation = _.includes(
      toggles,
      `fundingOpportunity-${fundingOpportunityId}-amendExistingScopeObligation`
    );
    const awardAmount = amendExistingScopeObligation ? undefined : fedShare;

    let newCommitmentsForEntity = _.map(selectedCommitments, (commitment) => {
      return {
        ...commitment,
        awardAmount,
      };
    });

    if (newEntityMap[entityId].commitment.length === 0) {
      newEntityMap[entityId] = {
        ...newEntityMap[entityId],
        commitment: newCommitmentsForEntity,
      };
    } else {
      newEntityMap[entityId] = {
        ...newEntityMap[entityId],
        commitment: [...newEntityMap[entityId].commitment, ...newCommitmentsForEntity],
      };
    }

    this.setState(
      {
        entityMap: newEntityMap,
        loadingEntityData: true,
        selectedCommitments: [],
      },
      () => {
        this.refreshCommitmentsInUse().then((commitmentsInUse) => {
          this.setState(
            {
              loadingEntityData: false,
              commitmentsInUse: commitmentsInUse,
            },
            () => {
              let entity = this.state.entityMap[entityId].entity;
              this.saveEntity(entity);
            }
          );
        });
      }
    );
  };

  removeCommitmentFromEntity = (entityId, commitmentToRemove) => {
    let {entityMap, commitmentsInUse} = this.state;
    let newEntityMap = entityMap;
    let commitmentsForEntity = newEntityMap[entityId].commitment;
    commitmentsForEntity = this.filterCommitments(commitmentsForEntity, [
      commitmentToRemove,
    ]);
    newEntityMap[entityId] = {
      ...newEntityMap[entityId],
      commitment: commitmentsForEntity,
    };
    this.setState(
      {
        entityMap: newEntityMap,
        loadingEntityData: true,
        deleteModalOpen: false,
        deleteModalEntity: '',
        deleteModalCommitment: {},
      },
      () => {
        this.refreshCommitmentsInUse().then((commitmentsInUse) => {
          this.setState(
            {
              loadingEntityData: false,
              commitmentsInUse: commitmentsInUse,
            },
            () => {
              let entity = this.state.entityMap[entityId].entity;
              this.saveEntity(entity);
            }
          );
        });
      }
    );
  };

  refreshCommitmentsInUse = () => {
    let {entityMap} = this.state;
    let commitmentsInUse = [];
    _.forIn(entityMap, (value) => {
      let commitments = _.get(value, 'commitment', []);
      commitmentsInUse = _.concat(commitmentsInUse, commitments);
    });
    commitmentsInUse = _.map(
      _.uniqWith(commitmentsInUse, this.compareCommitments),
      (commitment) => {
        return {...commitment, awardAmount: undefined};
      }
    );
    return this.retrieveCommitments(commitmentsInUse)
      .then((retrievedCommitments) => {
        return retrievedCommitments;
      })
      .catch((e) => {
        console.error('e');
        return [];
      });
  };

  saveEntity = (entity) => {
    let {entityType} = this.props;
    let {entities, entityMap, commitmentsInUse} = this.state;
    let entityId = entity.entityId;
    let entityCommitments = this.state.entityMap[entityId].commitment;
    let entityIndex = this.state.entityMap[entityId].entityIndex;
    let entityPayload = _.get(entity, 'payload', {});
    let updatedPayload = {
      ...entityPayload,
      commitment: entityCommitments,
    };
    let updatedEntity = {
      ...entity,
      payload: updatedPayload,
    };

    let filteredCommitments = _.map(entityCommitments, (commitment) => {
      let commitmentInUse = _.find(commitmentsInUse, (commitmentInUse) =>
        this.compareCommitments(commitment, commitmentInUse)
      );
      return {
        commitmentNumberId: commitment.commitmentNumberId,
        commitmentLineNumber: commitment.commitmentLineNumber,
        awardAmount: commitment.awardAmount,
        region: commitment.region,
        accsline: commitment.accsline,
        exceedsAvailableAmount:
          commitment.awardAmount >
          (commitmentInUse
            ? commitmentInUse.commitmentAvailableAmount
            : commitment.awardAmount),
      };
    });

    let dataPath = this.props.contextPathToSave;

    if (!this.props.hasSingleEntity) {
      this.props.saveEntityData(
        `${dataPath}[${entityIndex}].payload.commitment`,
        entityType,
        filteredCommitments,
        null,
        null,
        `${dataPath}.${entityIndex}`,
        true
      );
    } else {
      this.props.saveEntityData(
        `${dataPath}.payload.commitment`,
        entityType,
        filteredCommitments,
        null,
        null,
        `${dataPath}`,
        true
      );
    }

    let newEntityMap = {...entityMap};
    newEntityMap[entityId] = {...newEntityMap[entityId], entity: updatedEntity};
    let updatedEntities = [...entities];
    updatedEntities[
      _.findIndex(entities, (entity) => entity.entityId === entityId)
    ] = updatedEntity;
    this.setState({
      entities: updatedEntities,
      entityMap: newEntityMap,
    });
  };

  calculateTotalAvailableAmount = (commitment) => {
    let {entityMap} = this.state;
    let availableAmount = _.get(commitment, 'commitmentAvailableAmount', '0');
    let totalAwardAmount = 0;
    _.forIn(entityMap, (entity) => {
      let entityCommitments = _.get(entity, 'commitment');
      let matchingCommitment = _.find(entityCommitments, (commitmentForEntity) =>
        this.compareCommitments(commitmentForEntity, commitment)
      );
      if (matchingCommitment) {
        totalAwardAmount = safeAdd(
          totalAwardAmount,
          _.get(matchingCommitment, 'awardAmount', '0')
        );
      }
    });
    return safeSubstract(availableAmount, totalAwardAmount);
  };

  renderModal = () => {
    let {
      commitmentsInUse,
      returnedCommitments,
      regionFilter,
      commitmentNumberFilter,
      selectedEntity,
      selectedEntityIndex,
      selectedCommitments,
      retrievingCommitments,
      regions,
      entityMap,
    } = this.state;
    let entityDisplay = selectedEntity.subGrantId
      ? selectedEntity.subGrantId
      : selectedEntity.grantId;

    let commitmentsInUseMessage = selectedEntity.subGrantId
      ? 'Commitments covering other subapplications for this application'
      : 'Commitments currently in use for this application';
    let commitmentsInUseSummary = 'Commitments currently in use';
    let returnedCommitmentsMessage = '';
    let returnedCommitmentsSummary = 'Commitments available to add';

    // Filtering out commitments already added to the entity
    commitmentsInUse = this.filterCommitments(
      commitmentsInUse,
      entityMap[selectedEntity.entityId].commitment
    );
    returnedCommitments = this.filterCommitments(
      returnedCommitments,
      entityMap[selectedEntity.entityId].commitment
    );
    return (
      <FemaGoModal
        open={this.state.modalOpen}
        size="large"
        title="Add commitments"
        cancelAction={() => {
          this.setState({
            modalOpen: false,
            retrievingCommitments: false,
            returnedCommitments: [],
            regionFilter: null,
            commitmentNumberFilter: '',
          });
        }}
        confirmAction={() => {
          this.addCommitmentsToEntity(selectedEntity.entityId);
        }}
        buttonText="Add commitments"
        disableButton={
          !selectedCommitments ||
          selectedCommitments.length === 0 ||
          this.state.loadingEntityData
        }
      >
        <p>Identify the commitments you want to add for {entityDisplay}</p>
        <Segment>
          <Header as="h2">Search</Header>
          <Grid>
            <Grid.Row>
              <Grid.Column verticalAlign="middle">
                <InlineSelect
                  label="Region"
                  title="Region"
                  id="regionFilter"
                  name="regionFilter"
                  options={regions}
                  handleChange={this.onRegionChange}
                  value={regionFilter || regionFilter == 0 ? regionFilter : null}
                />
              </Grid.Column>
              <Grid.Column verticalAlign="middle" width={4}>
                <InlineTextBoxField
                  value={commitmentNumberFilter}
                  title="Commitment number"
                  label="Commitment number"
                  id="commitmentNumberFilter"
                  name="commitmentNumberFilter"
                  handleChange={this.onCommitmentNumberChange}
                />
              </Grid.Column>
              <Grid.Column verticalAlign="bottom">
                <Button
                  primary
                  onClick={() => {
                    this.setState(
                      {
                        retrievingCommitments: true,
                      },
                      this.retrieveCommitmentsToAdd
                    );
                  }}
                >
                  Search
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
        {retrievingCommitments ? (
          <Loader inline="centered" active>
            Loading...
          </Loader>
        ) : returnedCommitments && returnedCommitments.length > 0 ? (
          this.renderCommitments(
            selectedEntityIndex,
            returnedCommitments,
            returnedCommitmentsSummary,
            returnedCommitmentsMessage,
            true
          )
        ) : (
          commitmentsInUse &&
          commitmentsInUse.length > 0 &&
          this.renderCommitments(
            selectedEntityIndex,
            commitmentsInUse,
            commitmentsInUseSummary,
            commitmentsInUseMessage,
            true
          )
        )}
      </FemaGoModal>
    );
  };

  renderCommitments = (
    entityIndex,
    commitments,
    summary,
    header,
    toAdd,
    entity = null
  ) => {
    let {
      selectedCommitments,
      commitmentsInUse,
      deleteModalOpen,
      deleteModalCommitment,
      deleteModalEntity,
    } = this.state;
    let {
      deleteModalHeader,
      deleteModalContent,
      displayRegionAlert,
      regionAlertHeader,
      regionAlertContent,
    } = this.props;
    const regionHeader = regionAlertHeader
      ? regionAlertHeader
      : 'The commitments chosen below containing a yellow warning symbol are commitments from a different region than the subgrant being funded.';
    const regionContent = regionAlertContent
      ? regionAlertContent
      : 'You can continue, but may have selected an incorrect commitment.';
    let organization = _.get(this.props, 'organization', {});
    let nonMatchingRegions = _.sumBy(commitments, (commitment) => {
      return commitment.region !== organization.region ? 1 : null;
    });
    return (
      <React.Fragment>
        {header && <Header as="h2">{header}</Header>}
        {displayRegionAlert && nonMatchingRegions > 0 && (
          <Alert type="warning" header={regionHeader} content={regionContent} />
        )}
        <FemaGoTable type="static" summary={summary}>
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              {toAdd && <FemaGoTable.HeaderCell />}
              <FemaGoTable.HeaderCell>
                Commitment number - sequence number
              </FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>
                <center>Region</center>
              </FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>End date</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>ACCS code</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Available amount</FemaGoTable.HeaderCell>
              {!toAdd && entity && (
                <FemaGoTable.HeaderCell>
                  Amount awarded this action (+/-)
                </FemaGoTable.HeaderCell>
              )}
              {!toAdd && entity && <FemaGoTable.HeaderCell />}
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>
            {commitments.map((row, index) => {
              let commitmentToRender = _.find(commitmentsInUse, (commitment) => {
                return this.compareCommitments(commitment, row);
              });
              let {
                commitmentNumberId,
                commitmentEndDate,
                commitmentAvailableAmount,
                accsline,
                region,
                commitmentLineNumber,
              } = commitmentToRender ? commitmentToRender : row;
              region = region ? region : _.get(row, 'region', null);
              let awardAmount = row.awardAmount;

              let commitmentRegionMatch = region === organization.region;

              return (
                <React.Fragment key={`commitmentFragment-${entityIndex}-${index}`}>
                  <FemaGoTable.Row key={index}>
                    {toAdd && (
                      <FemaGoTable.CheckboxCell
                        label="Select commitment"
                        hideLabel={true}
                        checked={_.includes(selectedCommitments, row)}
                        collapsing={true}
                        handleChange={(label, value) => {
                          this.handleCheckBoxChange(row, value);
                        }}
                      />
                    )}
                    <FemaGoTable.TextCell>
                      {commitmentNumberId + ' - ' + commitmentLineNumber}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      <center>
                        {displayRegionAlert && !commitmentRegionMatch && (
                          <Icon name="exclamation triangle" color="yellow" />
                        )}
                        {region ? (region == '0' ? 'HQ' : region) : ''}
                      </center>
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertDateForDisplay(commitmentEndDate, true)}
                    </FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>{accsline}</FemaGoTable.TextCell>
                    <FemaGoTable.TextCell>
                      {convertValueToDollar(commitmentAvailableAmount)}
                    </FemaGoTable.TextCell>
                    {!toAdd && entity && (
                      <FemaGoTable.DollarCell
                        name="Amount awarded"
                        title="Amount awarded"
                        value={awardAmount}
                        handleChange={(name, value) => {
                          this.handleAmountChange(row, entity, value);
                        }}
                        handleBlur={() => {
                          this.saveEntity(entity);
                        }}
                        allowNegative={true}
                        displayError={
                          this.displayCommitmentError(entityIndex, index, 'awardAmount')
                            .displayError
                        }
                        errorMessages={
                          this.displayCommitmentError(entityIndex, index, 'awardAmount')
                            .errorMessages
                        }
                      />
                    )}
                    {!toAdd && entity && (
                      <FemaGoTable.TextCell>
                        <a
                          href="#"
                          title="Delete"
                          onClick={() => {
                            this.setState({
                              deleteModalOpen: true,
                              deleteModalCommitment: row,
                              deleteModalEntity: entity.entityId,
                            });
                          }}
                        >
                          <Icon name="close" />
                        </a>
                      </FemaGoTable.TextCell>
                    )}
                  </FemaGoTable.Row>
                </React.Fragment>
              );
            })}
          </FemaGoTable.Body>
        </FemaGoTable>
        {deleteModalOpen && deleteModalCommitment && deleteModalEntity && (
          <DeleteModal
            displayText={
              deleteModalContent
                ? deleteModalContent
                : 'Please confirm that you want to remove associated commitment with the subapplication'
            }
            displayTitle={deleteModalHeader ? deleteModalHeader : 'Confirm change'}
            open={deleteModalOpen}
            deleteAction={() => {
              this.removeCommitmentFromEntity(deleteModalEntity, deleteModalCommitment);
            }}
            cancelAction={() => {
              this.setState({
                deleteModalOpen: false,
                deleteModalEntity: '',
                deleteModalCommitment: {},
              });
            }}
          />
        )}
      </React.Fragment>
    );
  };

  renderEntityCard = (entity, filteredEntityIndex, cardHeaders, cardSummary) => {
    let {entityMap, loadingEntityData} = this.state;
    let {commitmentSummary, commitmentHeader} = this.props;
    let entityValues = entityMap[entity.entityId];
    let entityIndex = _.get(entityValues, 'entityIndex', filteredEntityIndex);
    let commitmentsForEntity = entityValues.commitment;
    let fedShareError = this.getFedShareErrors(entityIndex);
    let singleCommitmentError = this.getSingleCommitmentErrors(entityIndex);
    return (
      <Card fluid key={entity.entityId}>
        <Card.Content>
          {!fedShareError.isValid && (
            <React.Fragment>
              <Alert
                type="error"
                header={_.get(fedShareError, 'message')}
                key={`fedShareError-${entityIndex}`}
              />
            </React.Fragment>
          )}
          {!singleCommitmentError.isValid && (
            <React.Fragment>
              <Alert
                type="error"
                header={_.get(singleCommitmentError, 'header')}
                content={_.get(singleCommitmentError, 'message')}
                key={`singletCommitmentError-${entityIndex}`}
              />
            </React.Fragment>
          )}
          <FemaGoTable type="static" summary={cardSummary} basic="very">
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                {_.map(cardHeaders, (header, index) => (
                  <FemaGoTable.HeaderCell key={index}>
                    {header.header}
                  </FemaGoTable.HeaderCell>
                ))}
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            <FemaGoTable.Body>
              <FemaGoTable.Row>
                {_.map(cardHeaders, (header, index) => {
                  let path = header.path;
                  let value;
                  if (header.value) {
                    value = header.value;
                  } else if (header.template) {
                    let obj = {};
                    const keys = Object.keys(header.dataPaths);
                    _.each(
                      keys,
                      (key) => (obj[key] = _.get(entityValues, header.dataPaths[key], 0))
                    );
                    let tempValue = evaluateTemplateString(header.template, {...obj});
                    value =
                      header.type === 'dollar'
                        ? convertValueToDollar(tempValue)
                        : tempValue;
                  } else {
                    value =
                      header.type === 'dollar'
                        ? convertValueToDollar(_.get(entityValues, path, 0))
                        : _.get(entityValues, path);
                  }
                  if (header.key && header.key === 'subGrantId') {
                    value = (
                      <Link to={`/subgrant/${value}`} target="_blank">
                        {value}
                      </Link>
                    );
                  } else if (header.key && header.key === 'grantId') {
                    value = <Link to={`/grant/${value}`}>{value}</Link>;
                  }
                  return <FemaGoTable.TextCell key={index}>{value}</FemaGoTable.TextCell>;
                })}
              </FemaGoTable.Row>
            </FemaGoTable.Body>
          </FemaGoTable>
          {!loadingEntityData ? (
            this.renderCommitments(
              entityIndex,
              commitmentsForEntity,
              commitmentSummary,
              commitmentHeader,
              false,
              entity
            )
          ) : (
            <Loader inline="centered" active>
              Loading...
            </Loader>
          )}
          <a
            href="#"
            onClick={() => {
              this.setState({
                selectedEntity: entity,
                selectedEntityIndex: entityIndex,
                modalOpen: true,
              });
            }}
          >
            <Icon name="plus" /> Add commitment
          </a>
        </Card.Content>
      </Card>
    );
  };

  render() {
    let {entities, selectedEntity} = this.state;
    let {cardHeaders, cardSummary} = this.props;

    return (
      <React.Fragment>
        {_.map(entities, (entity, entityIndex) => {
          // if (awardRecStatusSet.has(entity.subGrantId)) {
          return this.renderEntityCard(entity, entityIndex, cardHeaders, cardSummary);
          //}
        })}
        {selectedEntity && this.renderModal()}
      </React.Fragment>
    );
  }
}

export const formatLineNumber = (lineNumber) => {
  while (lineNumber.length < 3) lineNumber = '0' + lineNumber;
  return lineNumber;
};

export const mapStateToProps = (state, ownProps) => {
  const props = {};
  props.fundingOpportunityData = _.get(
    state,
    'dynamicComponent.context.fundingOpportunityData'
  );
  props.token = state.auth.token;
  props.toggles = state.toggles.toggles;
  return props;
};

export const mapDispatchToProps = (dispatch) => ({
  getCommitment: (token, commitmentId) => {
    let action = ApiActions.commitment.getCommitment(token, commitmentId);
    const res = dispatch(action);
    return res;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectWithCore(FundingInformationSection));
